// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as View from "../../primitives/View.res.js";
import * as Field from "../../resources/layout-and-structure/Field.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as TextInput from "../../primitives/TextInput.res.js";
import * as ButtonPhased from "../../resources/actions/ButtonPhased.res.js";
import * as Client from "@apollo/client";
import * as SearchListItem from "../../resources/selection-and-input/SearchListItem.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as SearchListPopover from "../../resources/selection-and-input/SearchListPopover.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../../resources/overlays/OverlayTriggerView.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
let styles = {
  root: {
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "marginLeft-koQZXg": "marginLeft-x18wv8x9",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/modules/Catalog/CatalogCategoryPicker.res.js:21"
  },
  itemPlaceholderText: {
    "color-kMwMTN": "color-x1qqs05d",
    "font-kVVagm": "font-xpx012",
    "letterSpacing-kb6lSQ": "letterSpacing-x1owzkzt",
    "lineHeight-kLWn49": "lineHeight-x1vy86p0",
    "marginLeft-koQZXg": "marginLeft-x1swdo50",
    $$css: "wino-gc:src/modules/Catalog/CatalogCategoryPicker.res.js:28"
  }
};
let Raw = {};
let query = Client.gql(["query CategoriesQuery($first: Int, $after: String, $search: String!, $filterByShopIds: InFilter)  {\ncategories(first: $first, after: $after, search: $search, filterBy: {archived: EXCLUDED, hasChildren: false, shopIds: $filterByShopIds})  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \n}\n\n}\n\npageInfo  {\n__typename  \nhasNextPage  \nendCursor  \n}\n\n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.categories;
  let value$2 = value$1.edges;
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let value$5 = value$3.endCursor;
  return {
    categories: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedName: value$1.formattedName
          }
        };
      }),
      pageInfo: {
        __typename: value$3.__typename,
        hasNextPage: !(value$4 == null) ? value$4 : undefined,
        endCursor: !(value$5 == null) ? value$5 : undefined
      }
    }
  };
}
function serialize(value) {
  let value$1 = value.categories;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let endCursor = value$3 !== undefined ? value$3 : null;
  let value$4 = value$2.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$2.__typename;
  let pageInfo = {
    __typename: value$5,
    hasNextPage: hasNextPage,
    endCursor: endCursor
  };
  let value$6 = value$1.edges;
  let edges = value$6.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedName;
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    let node = {
      __typename: value$4,
      id: value$3,
      formattedName: value$2
    };
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      node: node
    };
  });
  let value$7 = value$1.__typename;
  let categories = {
    __typename: value$7,
    edges: edges,
    pageInfo: pageInfo
  };
  return {
    categories: categories
  };
}
function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeVariables(inp) {
  let a = inp.first;
  let a$1 = inp.after;
  let a$2 = inp.filterByShopIds;
  return {
    first: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined,
    search: inp.search,
    filterByShopIds: a$2 !== undefined ? serializeInputObjectInFilter(a$2) : undefined
  };
}
function makeVariables(first, after, search, filterByShopIds, param) {
  return {
    first: first,
    after: after,
    search: search,
    filterByShopIds: filterByShopIds
  };
}
function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}
let CategoriesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInFilter: makeInputObjectInFilter
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let useLazy = include.useLazy;
let CategoriesQuery_refetchQueryDescription = include.refetchQueryDescription;
let CategoriesQuery_use = include.use;
let CategoriesQuery_useLazyWithVariables = include.useLazyWithVariables;
let CategoriesQuery = {
  CategoriesQuery_inner: CategoriesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInFilter: makeInputObjectInFilter,
  refetchQueryDescription: CategoriesQuery_refetchQueryDescription,
  use: CategoriesQuery_use,
  useLazy: useLazy,
  useLazyWithVariables: CategoriesQuery_useLazyWithVariables
};
function throttle(callback, limit) {
  let wait = {
    contents: false
  };
  if (!wait.contents) {
    callback();
    wait.contents = true;
    setTimeout(() => {
      wait.contents = false;
    }, limit);
    return;
  }
}
function categoriesFromData(data) {
  return data.categories.edges.map(param => {
    let category = param.node;
    return {
      id: category.id,
      formattedName: category.formattedName
    };
  });
}
function CatalogCategoryPicker(props) {
  let onChange = props.onChange;
  let __errored = props.errored;
  let shopId = props.shopId;
  let value = props.value;
  let __triggerType = props.triggerType;
  let __compact = props.compact;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "normal";
  let compact = __compact !== undefined ? __compact : false;
  let triggerType = __triggerType !== undefined ? __triggerType : "cell";
  let errored = __errored !== undefined ? __errored : false;
  let match = useLazy(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  let match$1 = React.useState(() => "");
  let setSearchQuery = match$1[1];
  let searchQuery = match$1[0];
  let match$2 = React.useState(() => false);
  let setPopoverOpened = match$2[1];
  let match$3 = React.useState(() => false);
  let setFocused = match$3[1];
  let focused = match$3[0];
  let match$4 = Hover.use(undefined, undefined, undefined);
  let hovered = match$4[1];
  let ref = match$4[0];
  let activeShop = Auth.useActiveShop();
  let categoriesFilterByShopIds = shopId !== undefined ? {
    _in: [shopId]
  } : activeShop !== undefined ? {
    _in: [activeShop.id]
  } : undefined;
  let queryStatusRef = React.useRef(undefined);
  let hasNextPageRef = React.useRef(false);
  let endCursorRef = React.useRef("");
  React.useEffect(() => {
    if (queryResults.TAG === "Executed") {
      let match = queryResults._0;
      let match$1 = match.data;
      if (match$1 !== undefined) {
        let match$2 = match$1.categories.pageInfo;
        let hasNextPage = match$2.hasNextPage;
        if (hasNextPage !== undefined) {
          let endCursor = match$2.endCursor;
          if (endCursor !== undefined) {
            queryStatusRef.current = match.networkStatus;
            hasNextPageRef.current = hasNextPage;
            endCursorRef.current = endCursor;
          }
        }
      }
    }
  }, [queryResults]);
  React.useEffect(() => {
    if (focused) {
      executeQuery(undefined, undefined, makeVariables(20, undefined, searchQuery, categoriesFilterByShopIds, undefined));
    }
  }, [searchQuery, focused]);
  let fetchMore = React.useCallback(() => {
    let match = hasNextPageRef.current;
    if (queryResults.TAG !== "Executed") {
      return;
    }
    let match$1 = queryResults._0;
    if (match$1.data !== undefined && match) {
      match$1.fetchMore(undefined, undefined, makeVariables(20, endCursorRef.current, searchQuery, categoriesFilterByShopIds, undefined), (prevResult, param) => {
        let fetchMoreResult = param.fetchMoreResult;
        if (fetchMoreResult === undefined) {
          return prevResult;
        }
        let newCategories = fetchMoreResult.categories;
        return {
          categories: {
            __typename: newCategories.__typename,
            edges: prevResult.categories.edges.concat(newCategories.edges),
            pageInfo: newCategories.pageInfo
          }
        };
      }, undefined);
      return;
    }
  }, [queryResults]);
  let onEndReached = offset => {
    let match = offset < 50;
    let match$1 = queryStatusRef.current;
    if (match && match$1 === "Ready") {
      return throttle(fetchMore, 850);
    }
  };
  let renderEndItem = React.useCallback(() => {
    let newrecord = {
      ...{
        className: "color-x1qqs05d font-xpx012 letterSpacing-x1owzkzt lineHeight-x1vy86p0 marginLeft-x1swdo50",
        "data-style-src": "wino-gc:src/modules/Catalog/CatalogCategoryPicker.res.js:28"
      }
    };
    let tmp;
    if (queryResults.TAG === "Executed") {
      let match = queryResults._0;
      let match$1 = match.data;
      tmp = match.loading ? I18n.t("Loading...") : match.error !== undefined ? I18n.t("Loading error") : match$1 !== undefined && match$1.categories.edges.length === 0 ? I18n.t("No result found") : null;
    } else {
      tmp = I18n.t("Loading...");
    }
    newrecord.children = tmp;
    return JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx("span", newrecord),
      spaceLeft: "small"
    });
  }, [queryResults]);
  let renderEndActions = React.useMemo(() => {
    if (queryResults.TAG !== "Executed") {
      return;
    }
    let match = queryResults._0.data;
    if (match === undefined) {
      return;
    }
    let match$1 = match.categories.pageInfo.hasNextPage;
    if (match$1 !== undefined && !match$1) {
      return () => [JsxRuntime.jsx(SearchListItem.make, {
        name: I18n.t("Not classified"),
        onPress: () => {
          setPopoverOpened(param => false);
          onChange("NotClassifiedCategory");
        }
      })];
    }
  }, [queryResults]);
  let onToggle = opened => {
    setFocused(param => opened);
    setPopoverOpened(param => opened);
  };
  let items = React.useMemo(() => {
    if (queryResults.TAG !== "Executed") {
      return;
    }
    let data = queryResults._0.data;
    if (data !== undefined) {
      return categoriesFromData(data);
    }
  }, [queryResults]);
  let itemToValue = category => category.id;
  let itemToOption = category => category.formattedName;
  let newrecord = {
    ...{
      className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf marginLeft-x18wv8x9 width-xh8yej3",
      "data-style-src": "wino-gc:src/modules/Catalog/CatalogCategoryPicker.res.js:21"
    }
  };
  return JsxRuntime.jsx(View.make, (newrecord.children = JsxRuntime.jsx(SearchListPopover.make, {
    children: triggerType === "input" ? JsxRuntime.jsx(Field.make, {
      children: JsxRuntime.jsx(OverlayTriggerView.make, {
        children: JsxRuntime.jsx(TextInput.make, {
          placeholder: props.placeholder,
          readOnly: true,
          style: {
            width: "100%"
          },
          value: value
        }),
        preset: {
          NAME: "inputField",
          VAL: {
            required: false
          }
        },
        size: compact ? "compact" : "normal",
        growContent: true,
        icon: focused ? "arrow_up_light" : "arrow_down_light",
        hovered: hovered,
        focused: focused
      }),
      label: I18n.t("Category"),
      ref: ref
    }) : JsxRuntime.jsx(ButtonPhased.make, {
      children: value,
      variation: variation,
      hovered: hovered,
      compact: compact,
      focused: focused,
      errored: errored,
      ref: ref
    }),
    expendableWidth: triggerType === "input",
    items: items,
    itemToValue: itemToValue,
    itemToOption: itemToOption,
    opened: match$2[0],
    onSearchQueryChange: value => setSearchQuery(param => value),
    onChange: value => onChange({
      TAG: "CommonCategory",
      _0: value
    }),
    onToggle: onToggle,
    onEndReached: onEndReached,
    renderEndItem: renderEndItem,
    renderEndActions: renderEndActions
  }), newrecord));
}
let make = React.memo(CatalogCategoryPicker);
let edgesPerFetch = 20;
export { styles, CategoriesQuery, throttle, edgesPerFetch, categoriesFromData, make };
/* styles Not a pure module */